import {DatePickerInput} from '@/components/atoms'
import {withJsonFormsControlProps} from '@jsonforms/react'
import PropTypes from 'prop-types'

const DatePickerComponent = props => {
  /**
   * @typedef {Object} Props
   * @property {function} handleChange - Function to handle changes in the date picker.
   * @property {string} label - Label for the date picker control.
   * @property {Object} data - Data object associated with the date picker.
   * @property {string} path - Path to the data in the form.
   * @property {Object} errors - Object containing validation errors.
   * @property {Object} schema - JSON schema for the date picker.
   * @property {Object} uischema - UI schema for the date picker.
   * @property {boolean} required - Indicates if the date picker is required.
   */
  const {handleChange, label, data, path, errors, schema, uischema, required} = props
  return (
    <DatePickerInput
      value={data}
      label={label}
      updateValue={(newVal, validControl) => {
        handleChange(path, newVal)
        handleChange(path + 'Valid', validControl)
      }}
      errors={errors}
      schema={schema}
      uiSchema={uischema}
      required={required}
    />
  )
}

DatePickerComponent.propTypes = {
  handleChange: PropTypes.func,
  label: PropTypes.string,
  data: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  path: PropTypes.string,
  errors: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  schema: PropTypes.object,
  uischema: PropTypes.object,
  required: PropTypes.bool,
}

export const DatePickerControl = withJsonFormsControlProps(DatePickerComponent)
export default DatePickerControl
